import React, { useState } from "react";
import InputSearch from "../InputSearch";
import CollectionCard from "./CollectionCard";

const Collections = () => {
  const dummy = [
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
    {
      name: "Obsidian",
      owned: false,
      completed: false,
    },
  ];

  const [dataToDisplay, setDataToDisplay] = useState([...dummy]);

  const handleDisplay = (event, displayType) => {
    if (displayType === "all") {
      setDataToDisplay([...dummy]);
    } else if (displayType === "owned") {
      const temp = dummy.filter((val) => val.owned === true);
      setDataToDisplay([...temp]);
    } else if (displayType === "need") {
      const temp = dummy.filter((val) => val.owned === false);
      setDataToDisplay([...temp]);
    }
  };

  const handleCompleted = (e) => {
    const complete = e.target.checked;
    if (complete) {
      const temp = dummy.filter((val) => val === true);
      setDataToDisplay([...temp]);
    } else {
      const temp = dummy.map((val) => val);
      setDataToDisplay([...temp]);
    }
  };

  return (
    <div>
      <div className="w-full bg-pinkColor fixed z-50 gap-y-2 -mt-24 flex flex-col justify-center items-center">
        <InputSearch placeholder="Search" />
        <div className="w-full flex justify-between uppercase items-center font-extrabold text-sm">
          <div className="bg-grayColor w-6/12 py-2 text-center">
            international
          </div>
          <div className="bg-slate-200 w-6/12 py-2 text-slate-500 text-center">
            japanese
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center gap-x-10 py-4 -ml-10 mt-24">
        <button
          onClick={(e) => handleDisplay(e, "all")}
          className="uppercase font-bold text-sm border-b-4 border-pinkColor w-14"
        >
          all
        </button>
        <button
          onClick={(e) => handleDisplay(e, "owned")}
          className="uppercase font-bold text-sm border-b-4 border-grayColor w-14"
        >
          owned
        </button>
        <button
          onClick={(e) => handleDisplay(e, "need")}
          className="uppercase font-bold text-sm"
        >
          need
        </button>
      </div>

      <div className="flex w-full justify-center items-center gap-x-4">
        <p>Hide Completed:</p>
        <input
          onClick={handleCompleted}
          value="test"
          type="checkbox"
          className="form-checkbox border-2 border-pinkColor rounded-md text-pinkColor h-5 w-5"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mx-10 md:mx-32 gap-4 mt-6 mb-32">
        {dataToDisplay.map((val, idx) => (
            <CollectionCard />
        ))}
      </div>
    </div>
  );
};

export default Collections;
